// import React from 'react'
// import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaIndustry, FaIdBadge } from "react-icons/fa";
// import logo from '../Images/SGI-removebg-preview.png'
// const Contactus = () => {
//     return (


//         <div
//             style={{
//                 width: "90%",
//                 maxWidth: "90%",
//                 margin: "40px auto",
//                 background: "linear-gradient(to right, #f8f8f8, #ffffff)",
//                 // background:"white",
//                 padding: "2%",
//                 borderRadius: 20,
//                 boxShadow: "0 12px 30px rgba(0, 0, 0, 0.40)",
//                 fontFamily: "'Segoe UI', sans-serif",
//                 color: "#333",

//                 // position: "relative",
//             }}
//         >
//             {/* Logo and Heading */}
//             <div style={{ textAlign: "center" }}>
//                 <img
//                     src={logo}
//                     alt="Company Logo"
//                     style={{
//                         width: "60%",
//                         maxWidth: 300,
//                         height: "auto",

//                     }}
//                 />

//                 <h1
//                     style={{
//                         fontSize: "clamp(20px, 4vw, 30px)",
//                         textAlign: "center",
//                         textDecoration: "underline",
//                         textDecorationColor: "#ff6500",
//                         color: "#121e4b",
//                         textDecorationThickness: "2px",
//                         textUnderlineOffset: "10px",
//                         letterSpacing: "2px",
//                         marginTop: 10,
//                     }}
//                 >
//                     StructGuard Infra Product & Services LLP
//                 </h1>

//                 {/* <p style={{ fontSize: "clamp(12px, 2vw, 16px)", color: "#555" }}>
//                     Structural Engineering Consultants
//                 </p> */}
//             </div>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: 30, marginTop: 30 }}>
//                 {/* Row 1: Maps */}
//                 <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
//                     {/* Map 1 */}
//                     <div style={{ flex: '1 1 30%', minWidth: 300, height: 'auto', padding: 10 }}>
//                         {/* Heading */}
//                         <h2 style={{ fontSize: 16, marginBottom: 8, color: "#121e4b" }}>
//                             <FaMapMarkerAlt style={{ marginRight: 8 }} />
//                             Pune Office
//                         </h2>

//                         {/* Address */}
//                         <p style={{ fontSize: 14, marginBottom: 10 }}>
//                             418 Platinum 9, Pashan-Sus Road,<br />
//                             Behind Audi Showroom, Baner,<br />
//                             Pune MH-411045
//                         </p>

//                         {/* Embedded Map */}
//                         <div style={{   border: '2px solid orange',borderRadius: '10%',  padding: '16px',  boxSizing: 'border-box',  }}>
//                             <iframe
//                                 title="Pune Office Map"
//                                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15130.26272718813!2d73.75072338774807!3d18.548518803735096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bee9fafbc545%3A0x7ba7e43566bcaa7d!2sPlatinum%209!5e0!3m2!1sen!2sin!4v1753272309284!5m2!1sen!2sin"
//                                 width="100%"
//                                 height="100%"
//                                 style={{ border: 0 }}
//                                 loading="lazy"
//                                 allowFullScreen

//                                 referrerPolicy="no-referrer-when-downgrade"
//                             ></iframe>
//                         </div>
//                     </div>

//                     {/* Map 2 */}
//                     <div style={{ flex: '1 1 30%', minWidth: 300, height: 'auto', padding: 10 }}>
//                         {/* Heading */}
//                         <h2 style={{ fontSize: 16, marginBottom: 8, color: "#121e4b" }}>
//                             <FaMapMarkerAlt style={{ marginRight: 8 }} />
//                             Pune Factory Address
//                         </h2>

//                         {/* Address */}
//                         <p style={{ fontSize: 14, marginBottom: 10 }}>
//                             Satav wadi,<br />
//                             Mulshi, Lavale, <br />
//                             Pune, Maharashtra 412115

//                         </p>

//                         {/* Embedded Map */}
//                         <div style={{   border: '2px solid orange',borderRadius: '10%',  padding: '16px',  boxSizing: 'border-box'  }}>
//                             <iframe
//                                 title="Pune Office Map"
//                                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.8063353485945!2d73.70578257484587!3d18.537651782559188!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bd66e914a9b9%3A0x7dccd315d8e326f9!2sStructGuard%20Infra%20Products%20%26%20Services%20LLP!5e0!3m2!1sen!2sin!4v1753272693486!5m2!1sen!2sin"
//                                 width="100%"
//                                 height="100%"
//                                 style={{ border: 0 }}
//                                 loading="lazy"
//                                 allowFullScreen
//                                 referrerPolicy="no-referrer-when-downgrade"
//                             ></iframe>
//                         </div>
//                     </div>


//                     {/* Map 3 */}
//                     <div style={{ flex: '1 1 30%', minWidth: 300, height: 'auto', padding: 10 }}>
//                         {/* Heading */}
//                         <h2 style={{ fontSize: 16, marginBottom: 8, color: "#121e4b" }}>
//                             <FaMapMarkerAlt style={{ marginRight: 8 }} />
//                             Nagpur Factory Address
//                         </h2>

//                         {/* Address */}
//                         <p style={{ fontSize: 14, marginBottom: 10 }}>
//                             Plot no U156-1,<br />
//                             Electronic zone square,<br />
//                             MIDC Hingna, Nagpur, 440016

//                         </p>

//                         {/* Embedded Map */}
//                         <div style={{  border: '2px solid orange',borderRadius: '10%',  padding: '16px',  boxSizing: 'border-box' }}>
//                             <iframe
//                                 title="Pune Office Map"
//                                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d465.27067697779705!2d78.98839303901315!3d21.105970400000007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4958a6371780b%3A0xf691fe13a569036a!2sVEDAS%20INDUSTRIES!5e0!3m2!1sen!2sin!4v1753272910321!5m2!1sen!2sin"
//                                 width="100%"
//                                 height="100%"
//                                 style={{ border: 10 }}
//                                 loading="lazy"
//                                 allowFullScreen
//                                 referrerPolicy="no-referrer-when-downgrade"
//                             ></iframe>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Row 2: Contact Details */}
//                 <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
//                     {/* Phone */}
//                     <div style={{ flex: '1 1 30%', minWidth: 250 }}>
//                         <h2 style={{ fontSize: 16, color: '#121e4b' }}><FaPhone style={{ marginRight: 8 }} />Mobile</h2>
//                         <p style={{ fontSize: 14 }}>
//                             <a href="tel:8956134732" style={{ color: '#121e4b', textDecoration: 'none' }}>8956134732</a> /
//                             <a href="tel:8956134733" style={{ color: '#121e4b', textDecoration: 'none' }}> 8956134733</a>
//                         </p>
//                     </div>

//                     {/* Email */}
//                     <div style={{ flex: '1 1 30%', minWidth: 250 }}>
//                         <h2 style={{ fontSize: 16, color: '#121e4b' }}><FaEnvelope style={{ marginRight: 8 }} />Email</h2>
//                         <p style={{ fontSize: 14 }}>
//                             <a href="mailto:info@structguard.com" style={{ color: '#121e4b', textDecoration: 'none' }}>info@structguard.com</a>
//                         </p>
//                     </div>

//                     {/* GSTN */}
//                     <div style={{ flex: '1 1 30%', minWidth: 250 }}>
//                         <h2 style={{ fontSize: 16, color: '#121e4b' }}><FaIdBadge style={{ marginRight: 8 }} />GSTN</h2>
//                         <p style={{ fontSize: 14 }}>27AFBFS2382B1Z8</p>
//                     </div>
//                 </div>
//             </div>




//             {/* Footer */}
//             <div
//                 style={{
//                     borderTop: "1px solid #ddd",
//                     marginTop: 30,
//                     paddingTop: 10,
//                     textAlign: "center",
//                     fontSize: 13,
//                     color: "#888",
//                 }}
//             >
//                 © {new Date().getFullYear()} StructGuard Infra Products & Services LLP. All rights reserved.
//             </div>



//         </div>

//     )
// }

// const containerStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: 0,
//     width: '100%',
// };

// const rowStyle = {
//     display: 'flex',
//     width: '100%',
//     height: 'auto',
// };

// const colStyle = {
//     width: '50%',
//     boxSizing: 'border-box',
// };

// const mapWrapper = {
//     width: '100%',
//     height: '300px',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
// };

// const mapStyle = {
//     width: '100%',
//     height: '100%',
//     border: 0,
// };

// const headingStyle = {
//     fontSize: 16,
//     color: '#121e4b',
// };

// const textStyle = {
//     fontSize: 14,
// };

// const linkStyle = {
//     color: '#121e4b',
//     textDecoration: 'none',
// };

// export default Contactus

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
    FaPhone,
    FaEnvelope,
    FaMapMarkerAlt,
    FaIndustry,
    FaIdBadge,
    FaArrowRight,
    FaClock,
    FaBuilding,
    FaPaperPlane,
    FaQuoteRight,
    FaGlobeAsia,
} from "react-icons/fa";

import logo from "../Images/logo.png";

const Contactus = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [activeLocation, setActiveLocation] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const locations = [
        {
            type: "Corporate Office",
            title: "Pune Office",
            short: "Pune Office",
            icon: <FaBuilding />,
            address: (
                <>
                    418 Platinum 9, Pashan-Sus Road,
                    <br />
                    Behind Audi Showroom, Baner,
                    <br />
                    Pune MH-411045
                </>
            ),
            map:
                "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15130.26272718813!2d73.75072338774807!3d18.548518803735096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bee9fafbc545%3A0x7ba7e43566bcaa7d!2sPlatinum%209!5e0!3m2!1sen!2sin!4v1753272309284!5m2!1sen!2sin",
        },
        {
            type: "Manufacturing Facility",
            title: "Pune Factory",
            short: "Pune Factory",
            icon: <FaIndustry />,
            address: (
                <>
                    Satav Wadi,
                    <br />
                    Mulshi, Lavale,
                    <br />
                    Pune, Maharashtra 412115
                </>
            ),
            map:
                "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.8063353485945!2d73.70578257484587!3d18.537651782559188!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bd66e914a9b9%3A0x7dccd315d8e326f9!2sStructGuard%20Infra%20Products%20%26%20Services%20LLP!5e0!3m2!1sen!2sin!4v1753272693486!5m2!1sen!2sin",
        },
        {
            type: "Manufacturing Facility",
            title: "Nagpur Factory",
            short: "Nagpur Factory",
            icon: <FaIndustry />,
            address: (
                <>
                    Plot No. U156-1,
                    <br />
                    Electronic Zone Square,
                    <br />
                    MIDC Hingna, Nagpur, 440016
                </>
            ),
            map:
                "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3222.968549067869!2d78.98619647449844!3d21.10597538512336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4958a6371780b%3A0xf691fe13a569036a!2sVEDAS%20INDUSTRIES!5e1!3m2!1sen!2sin!4v1793093265047!5m2!1sen!2sin",
        },
    ];

    const contactItems = [
        {
            icon: <FaPhone />,
            title: "Call Us",
            label: "Speak with our team",
            value: "8956134732 / 8956134733",
            action: "tel:8956134732",
        },
        {
            icon: <FaEnvelope />,
            title: "Email Us",
            label: "Send your requirement",
            value: "info@structguard.com",
            action: "mailto:info@structguard.com",
        },
        {
            icon: <FaIdBadge />,
            title: "GSTIN",
            label: "Business identification",
            value: "27AFBFS2382B1Z8",
        },
    ];

    const fadeUp = {
        hidden: {
            opacity: 0,
            y: 35,
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.7,
                ease: "easeOut",
            },
        },
    };

    const stagger = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.12,
            },
        },
    };

    return (
        <div
            id="contact"
            style={{
                width: "100%",
                minHeight: "100vh",
                background: "#ffffff",
                color: "#17232b",
                fontFamily: "'Segoe UI', Arial, sans-serif",
                overflow: "hidden",
            }}
        >
            {/* =========================================================
          HERO
      ========================================================== */}

            <section
                style={{
                    position: "relative",
                    padding: isMobile ? "70px 20px 55px" : "95px 7% 80px",
                    background:
                        "linear-gradient(135deg, #ffffff 0%, #fff8f3 55%, #ffffff 100%)",
                    overflow: "hidden",
                }}
            >
                {/* Decorative circles */}

                <motion.div
                    animate={{
                        y: [0, -18, 0],
                        rotate: [0, 8, 0],
                    }}
                    transition={{
                        duration: 6,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                    style={{
                        position: "absolute",
                        right: "-70px",
                        top: "30px",
                        width: 220,
                        height: 220,
                        borderRadius: "50%",
                        border: "35px solid rgba(255,101,0,0.06)",
                    }}
                />

                <motion.div
                    animate={{
                        y: [0, 20, 0],
                    }}
                    transition={{
                        duration: 5,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                    style={{
                        position: "absolute",
                        left: "-90px",
                        bottom: "-100px",
                        width: 260,
                        height: 260,
                        borderRadius: "50%",
                        background: "rgba(255,101,0,0.035)",
                    }}
                />

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    variants={stagger}
                    style={{
                        position: "relative",
                        zIndex: 2,
                        maxWidth: 1250,
                        margin: "0 auto",
                        textAlign: "center",
                    }}
                >
                    <motion.div variants={fadeUp}>
                        <img
                            src={logo}
                            alt="StructGuard Infra Products & Services LLP"
                            style={{
                                width: isMobile ? 210 : 270,
                                maxWidth: "80%",
                                height: "auto",
                                objectFit: "contain",
                                marginBottom: 25,
                            }}
                        />
                    </motion.div>

                    <motion.div
                        variants={fadeUp}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 8,
                            padding: "8px 15px",
                            borderRadius: 50,
                            background: "#fff1e8",
                            color: "#ff6500",
                            fontWeight: 700,
                            fontSize: 12,
                            letterSpacing: 1.5,
                            marginBottom: 18,
                        }}
                    >
                        <FaGlobeAsia />
                        CONNECT WITH STRUCTGUARD
                    </motion.div>

                    <motion.h1
                        variants={fadeUp}
                        style={{
                            margin: 0,
                            fontSize: "clamp(34px, 6vw, 64px)",
                            lineHeight: 1.05,
                            fontWeight: 800,
                            color: "#17232b",
                            letterSpacing: "-2px",
                        }}
                    >
                        Let’s Build Something
                        <span
                            style={{
                                display: "block",
                                color: "#ff6500",
                            }}
                        >
                            Strong Together.
                        </span>
                    </motion.h1>

                    <motion.p
                        variants={fadeUp}
                        style={{
                            maxWidth: 760,
                            margin: "25px auto 0",
                            color: "#65727a",
                            fontSize: isMobile ? 15 : 18,
                            lineHeight: 1.8,
                        }}
                    >
                        Have a requirement for precast concrete products, cover blocks,
                        door frames or other construction solutions? Connect with the
                        StructGuard team and let’s discuss your requirement.
                    </motion.p>

                    <motion.div
                        variants={fadeUp}
                        style={{
                            marginTop: 32,
                            display: "flex",
                            justifyContent: "center",
                            gap: 12,
                            flexWrap: "wrap",
                        }}
                    >
                        <motion.a
                            href="mailto:info@structguard.com"
                            whileHover={{
                                scale: 1.04,
                                boxShadow: "0 15px 30px rgba(255,101,0,0.22)",
                            }}
                            whileTap={{ scale: 0.97 }}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 10,
                                padding: "14px 22px",
                                borderRadius: 12,
                                background: "#ff6500",
                                color: "#ffffff",
                                textDecoration: "none",
                                fontWeight: 700,
                                fontSize: 14,
                            }}
                        >
                            <FaPaperPlane />
                            Send Enquiry
                        </motion.a>

                        <motion.a
                            href="tel:8956134732"
                            whileHover={{
                                scale: 1.04,
                                background: "#17232b",
                                color: "#ffffff",
                            }}
                            whileTap={{ scale: 0.97 }}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 10,
                                padding: "14px 22px",
                                borderRadius: 12,
                                border: "1px solid #dfe5e8",
                                background: "#ffffff",
                                color: "#17232b",
                                textDecoration: "none",
                                fontWeight: 700,
                                fontSize: 14,
                            }}
                        >
                            <FaPhone />
                            Call Our Team
                        </motion.a>
                    </motion.div>
                </motion.div>
            </section>

            {/* =========================================================
          CONTACT CARDS
      ========================================================== */}

            <section
                style={{
                    padding: isMobile ? "45px 20px" : "65px 7%",
                    background: "#ffffff",
                }}
            >
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.15 }}
                    variants={stagger}
                    style={{
                        maxWidth: 1250,
                        margin: "0 auto",
                        display: "grid",
                        gridTemplateColumns: isMobile
                            ? "1fr"
                            : "repeat(3, minmax(0, 1fr))",
                        gap: 18,
                    }}
                >
                    {contactItems.map((item, index) => (
                        <motion.div
                            key={item.title}
                            variants={fadeUp}
                            whileHover={{
                                y: -8,
                                boxShadow: "0 20px 45px rgba(23,35,43,0.10)",
                            }}
                            style={{
                                position: "relative",
                                padding: 25,
                                borderRadius: 18,
                                border: "1px solid #e7ecef",
                                background: "#ffffff",
                                overflow: "hidden",
                                transition: "0.3s ease",
                            }}
                        >
                            <div
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: 55,
                                    height: 4,
                                    background: "#ff6500",
                                    borderRadius: "0 0 10px 0",
                                }}
                            />

                            <div
                                style={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: 14,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "#fff1e8",
                                    color: "#ff6500",
                                    fontSize: 19,
                                    marginBottom: 18,
                                }}
                            >
                                {item.icon}
                            </div>

                            <div
                                style={{
                                    fontSize: 19,
                                    fontWeight: 800,
                                    marginBottom: 5,
                                }}
                            >
                                {item.title}
                            </div>

                            <div
                                style={{
                                    fontSize: 13,
                                    color: "#8a959c",
                                    marginBottom: 12,
                                }}
                            >
                                {item.label}
                            </div>

                            {item.action ? (
                                <a
                                    href={item.action}
                                    style={{
                                        color: "#17232b",
                                        textDecoration: "none",
                                        fontWeight: 700,
                                        fontSize: 14,
                                        wordBreak: "break-word",
                                    }}
                                >
                                    {item.value}
                                </a>
                            ) : (
                                <div
                                    style={{
                                        color: "#17232b",
                                        fontWeight: 700,
                                        fontSize: 14,
                                    }}
                                >
                                    {item.value}
                                </div>
                            )}
                        </motion.div>
                    ))}
                </motion.div>
            </section>

            {/* =========================================================
          LOCATIONS
      ========================================================== */}

            <section
                style={{
                    padding: isMobile ? "55px 20px" : "80px 7%",
                    background: "#f7f9fa",
                }}
            >
                <div
                    style={{
                        maxWidth: 1250,
                        margin: "0 auto",
                    }}
                >
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeUp}
                        style={{
                            marginBottom: 35,
                        }}
                    >
                        <div
                            style={{
                                color: "#ff6500",
                                fontSize: 12,
                                fontWeight: 800,
                                letterSpacing: 2,
                                marginBottom: 10,
                            }}
                        >
                            OUR LOCATIONS
                        </div>

                        <h2
                            style={{
                                margin: 0,
                                fontSize: "clamp(30px, 4vw, 48px)",
                                color: "#17232b",
                                fontWeight: 800,
                                letterSpacing: "-1px",
                            }}
                        >
                            Find StructGuard
                            <span style={{ color: "#ff6500" }}> near you.</span>
                        </h2>

                        <p
                            style={{
                                maxWidth: 650,
                                color: "#69767d",
                                lineHeight: 1.7,
                                marginTop: 12,
                                fontSize: 15,
                            }}
                        >
                            Our office and manufacturing locations support coordination,
                            production and supply requirements across different regions.
                        </p>
                    </motion.div>

                    {/* Location selector */}

                    <div
                        style={{
                            display: "flex",
                            gap: 10,
                            overflowX: "auto",
                            paddingBottom: 10,
                            marginBottom: 22,
                            scrollbarWidth: "none",
                        }}
                    >
                        {locations.map((location, index) => (
                            <motion.button
                                key={location.title}
                                onClick={() => setActiveLocation(index)}
                                whileTap={{ scale: 0.96 }}
                                style={{
                                    flex: "0 0 auto",
                                    border: "none",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    padding: "11px 16px",
                                    borderRadius: 50,
                                    background:
                                        activeLocation === index ? "#ff6500" : "#ffffff",
                                    color: activeLocation === index ? "#ffffff" : "#17232b",
                                    boxShadow:
                                        activeLocation === index
                                            ? "0 8px 20px rgba(255,101,0,0.20)"
                                            : "0 4px 12px rgba(23,35,43,0.05)",
                                    fontWeight: 700,
                                    fontSize: 13,
                                    transition: "0.25s ease",
                                }}
                            >
                                {location.icon}
                                {location.short}
                            </motion.button>
                        ))}
                    </div>

                    <motion.div
                        key={activeLocation}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.45 }}
                        style={{
                            display: "grid",
                            gridTemplateColumns: isMobile ? "1fr" : "0.8fr 1.5fr",
                            background: "#ffffff",
                            borderRadius: 24,
                            border: "1px solid #e5eaed",
                            overflow: "hidden",
                            boxShadow: "0 20px 60px rgba(23,35,43,0.08)",
                        }}
                    >
                        {/* Location details */}

                        <div
                            style={{
                                padding: isMobile ? 25 : 38,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}
                        >
                            <div
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 7,
                                    alignSelf: "flex-start",
                                    padding: "7px 11px",
                                    borderRadius: 50,
                                    background: "#fff1e8",
                                    color: "#ff6500",
                                    fontSize: 11,
                                    fontWeight: 800,
                                    letterSpacing: 0.8,
                                    marginBottom: 18,
                                }}
                            >
                                {locations[activeLocation].icon}
                                {locations[activeLocation].type}
                            </div>

                            <h3
                                style={{
                                    fontSize: "clamp(25px, 3vw, 34px)",
                                    margin: 0,
                                    fontWeight: 800,
                                    color: "#17232b",
                                }}
                            >
                                {locations[activeLocation].title}
                            </h3>

                            <div
                                style={{
                                    height: 3,
                                    width: 45,
                                    background: "#ff6500",
                                    borderRadius: 10,
                                    margin: "17px 0",
                                }}
                            />

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 12,
                                    color: "#66747b",
                                    lineHeight: 1.8,
                                    fontSize: 14,
                                }}
                            >
                                <FaMapMarkerAlt
                                    style={{
                                        color: "#ff6500",
                                        marginTop: 4,
                                        flexShrink: 0,
                                    }}
                                />

                                <span>{locations[activeLocation].address}</span>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    marginTop: 25,
                                    paddingTop: 20,
                                    borderTop: "1px solid #edf0f2",
                                    color: "#69767d",
                                    fontSize: 13,
                                }}
                            >
                                <FaClock style={{ color: "#ff6500" }} />
                                Connect with our team for business enquiries and product
                                requirements.
                            </div>
                        </div>

                        {/* Map */}

                        <div
                            style={{
                                minHeight: isMobile ? 300 : 440,
                                padding: isMobile ? 10 : 14,
                                background: "#edf1f3",
                            }}
                        >
                            <div
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    minHeight: isMobile ? 280 : 410,
                                    overflow: "hidden",
                                    borderRadius: 18,
                                    border: "1px solid #dde3e6",
                                }}
                            >
                                <iframe
                                    title={locations[activeLocation].title}
                                    src={locations[activeLocation].map}
                                    width="100%"
                                    height="100%"
                                    style={{
                                        border: 0,
                                        display: "block",
                                    }}
                                    loading="lazy"
                                    allowFullScreen
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </div>
                        </div>
                    </motion.div>
                </div>
            </section>

            {/* =========================================================
          WHY CONNECT
      ========================================================== */}

            <section
                style={{
                    padding: isMobile ? "60px 20px" : "85px 7%",
                    background: "#ffffff",
                }}
            >
                <div
                    style={{
                        maxWidth: 1250,
                        margin: "0 auto",
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr" : "1fr 1.2fr",
                        gap: isMobile ? 35 : 70,
                        alignItems: "center",
                    }}
                >
                    <motion.div
                        initial={{ opacity: 0, x: -40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                    >
                        <div
                            style={{
                                color: "#ff6500",
                                fontSize: 12,
                                fontWeight: 800,
                                letterSpacing: 2,
                                marginBottom: 12,
                            }}
                        >
                            WHY CONNECT WITH US?
                        </div>

                        <h2
                            style={{
                                margin: 0,
                                fontSize: "clamp(30px, 4vw, 47px)",
                                lineHeight: 1.1,
                                fontWeight: 800,
                                color: "#17232b",
                            }}
                        >
                            One team.
                            <br />
                            <span style={{ color: "#ff6500" }}>Multiple solutions.</span>
                        </h2>

                        <p
                            style={{
                                color: "#69767d",
                                lineHeight: 1.8,
                                fontSize: 15,
                                marginTop: 20,
                                maxWidth: 520,
                            }}
                        >
                            Whether you are looking for product information, pricing,
                            project requirements, bulk orders or supply coordination,
                            our team is ready to understand your requirement and guide you
                            to the right solution.
                        </p>

                        <motion.a
                            href="mailto:info@structguard.com"
                            whileHover={{
                                x: 5,
                            }}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 10,
                                marginTop: 20,
                                color: "#ff6500",
                                textDecoration: "none",
                                fontWeight: 800,
                                fontSize: 14,
                            }}
                        >
                            Start a conversation
                            <FaArrowRight />
                        </motion.a>
                    </motion.div>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={stagger}
                        style={{
                            display: "grid",
                            gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
                            gap: 15,
                        }}
                    >
                        {[
                            {
                                icon: <FaIndustry />,
                                title: "Product Enquiries",
                                text: "Discuss product specifications and requirements.",
                            },
                            {
                                icon: <FaQuoteRight />,
                                title: "Bulk Orders",
                                text: "Connect with us for project and bulk requirements.",
                            },
                            {
                                icon: <FaMapMarkerAlt />,
                                title: "Location Support",
                                text: "Reach our office and manufacturing locations.",
                            },
                            {
                                icon: <FaPhone />,
                                title: "Direct Assistance",
                                text: "Talk directly with the StructGuard team.",
                            },
                        ].map((item) => (
                            <motion.div
                                key={item.title}
                                variants={fadeUp}
                                whileHover={{
                                    y: -6,
                                    borderColor: "#ff6500",
                                }}
                                style={{
                                    padding: 23,
                                    borderRadius: 18,
                                    border: "1px solid #e7ecef",
                                    background: "#ffffff",
                                    transition: "0.3s ease",
                                }}
                            >
                                <div
                                    style={{
                                        width: 42,
                                        height: 42,
                                        borderRadius: 12,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "#fff1e8",
                                        color: "#ff6500",
                                        marginBottom: 16,
                                    }}
                                >
                                    {item.icon}
                                </div>

                                <div
                                    style={{
                                        fontWeight: 800,
                                        fontSize: 16,
                                        marginBottom: 8,
                                    }}
                                >
                                    {item.title}
                                </div>

                                <div
                                    style={{
                                        color: "#7a858b",
                                        fontSize: 13,
                                        lineHeight: 1.6,
                                    }}
                                >
                                    {item.text}
                                </div>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </section>

            {/* =========================================================
          FINAL CTA
      ========================================================== */}

            <section
                style={{
                    padding: isMobile ? "50px 20px" : "70px 7%",
                    background: "#17232b",
                }}
            >
                <motion.div
                    initial={{ opacity: 0, scale: 0.96 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    style={{
                        maxWidth: 1100,
                        margin: "0 auto",
                        textAlign: "center",
                    }}
                >
                    <div
                        style={{
                            color: "#ff6500",
                            fontSize: 12,
                            fontWeight: 800,
                            letterSpacing: 2,
                            marginBottom: 12,
                        }}
                    >
                        READY TO CONNECT?
                    </div>

                    <h2
                        style={{
                            margin: 0,
                            color: "#ffffff",
                            fontSize: "clamp(28px, 5vw, 48px)",
                            fontWeight: 800,
                        }}
                    >
                        Have a project in mind?
                    </h2>

                    <p
                        style={{
                            color: "#b7c0c5",
                            maxWidth: 650,
                            margin: "15px auto 25px",
                            lineHeight: 1.7,
                            fontSize: 15,
                        }}
                    >
                        Share your requirement with StructGuard and our team will connect
                        with you regarding the right product or solution.
                    </p>

                    <motion.a
                        href="mailto:info@structguard.com"
                        whileHover={{
                            scale: 1.05,
                            boxShadow: "0 15px 35px rgba(255,101,0,0.28)",
                        }}
                        whileTap={{ scale: 0.97 }}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 10,
                            padding: "15px 25px",
                            borderRadius: 12,
                            background: "#ff6500",
                            color: "#ffffff",
                            textDecoration: "none",
                            fontWeight: 800,
                            fontSize: 14,
                        }}
                    >
                        <FaEnvelope />
                        info@structguard.com
                    </motion.a>
                </motion.div>
            </section>

            {/* =========================================================
          FOOTER
      ========================================================== */}

            <footer
                style={{
                    background: "#111a20",
                    color: "#89949a",
                    textAlign: "center",
                    padding: "22px 20px",
                    fontSize: 12,
                }}
            >
                © {new Date().getFullYear()} StructGuard Infra Products & Services LLP.
                All rights reserved.
            </footer>
        </div>
    );
};

export default Contactus;